module.exports = __webpack_public_path__ + "static/introduction_logoM@2x-0880ebf60a241822adc7e153dcd6c5d1.png";